import React from 'react';
import { graphql } from 'gatsby';
import { OmTabsTwoColumnLayoutImageLeft } from '@om/component-library-react';
import TwoColumnImageLeftV2 from './TwoColumnImageLeftV2';

const TabsTwoColumnImageLeftV2 = ({
    tabsTwoColumnImageLeftV2Content,
    slot
}) => {
    if(!tabsTwoColumnImageLeftV2Content) {
        return '';
    }

    const {
        use_heading_as_h1,
        is_extended,
        has_boundary,
        section_heading,
        section_caption,
        tab_text_one,
        om_two_column_image_left_v2_one,
        tab_text_two,
        om_two_column_image_left_v2_two,
        tab_text_three,
        om_two_column_image_left_v2_three,
        tab_text_four,
        om_two_column_image_left_v2_four,
        tab_text_five,
        om_two_column_image_left_v2_five,
        tab_text_six,
        om_two_column_image_left_v2_six,
        call_me_back,
        button_text,
        button_url,
        open_tab,
        button_action_type,
    } = tabsTwoColumnImageLeftV2Content;

    return (
        <OmTabsTwoColumnLayoutImageLeft
            slot={slot}
            isExtended={is_extended}
            hasBoundary={has_boundary}
            tabTextOne={tab_text_one}
            tabTextTwo={tab_text_two}
            tabTextThree={tab_text_three}
            tabTextFour={tab_text_four}
            tabTextFive={tab_text_five}
            tabTextSix={tab_text_six}
            buttonText={button_text}
            buttonUrl={button_url ? button_url.href : ''}
            buttonActionType={button_action_type}
            callMeBackObject={call_me_back ? JSON.stringify(call_me_back) : ''}
            openTab={open_tab}
        >
            {
                use_heading_as_h1 ? <h1 slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} /> :  <span slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} />
            }
            {
                section_caption ? <span slot="section-caption" dangerouslySetInnerHTML={{__html: section_caption}} /> : ''
            }
            <TwoColumnImageLeftV2 slot="om-two-column-image-left-one" twoColumnImageLeftContent={om_two_column_image_left_v2_one[0]} />
            <TwoColumnImageLeftV2 slot="om-two-column-image-left-two" twoColumnImageLeftContent={om_two_column_image_left_v2_two[0]} />
            <TwoColumnImageLeftV2 slot="om-two-column-image-left-three" twoColumnImageLeftContent={om_two_column_image_left_v2_three[0]} />
            <TwoColumnImageLeftV2 slot="om-two-column-image-left-four" twoColumnImageLeftContent={om_two_column_image_left_v2_four[0]} />
            <TwoColumnImageLeftV2 slot="om-two-column-image-left-five" twoColumnImageLeftContent={om_two_column_image_left_v2_five[0]} />
            <TwoColumnImageLeftV2 slot="om-two-column-image-left-six" twoColumnImageLeftContent={om_two_column_image_left_v2_six[0]} />
        </OmTabsTwoColumnLayoutImageLeft>
    );
};

export const pageQuery = graphql`
fragment TabsTwoColumnLayoutImageLeftV2 on Contentstack_tabs_two_column_layout_image_left_v2 {
        uid
        use_heading_as_h1
        is_extended
        has_boundary
        section_heading
        section_caption
        tab_text_one
        om_two_column_image_left_v2_one {
            ...TwoColumnImageLeftV2
        }
        tab_text_two
        om_two_column_image_left_v2_two {
            ...TwoColumnImageLeftV2
        }
        tab_text_three
        om_two_column_image_left_v2_three {
            ...TwoColumnImageLeftV2
        }
        tab_text_four
        om_two_column_image_left_v2_four {
            ...TwoColumnImageLeftV2
        }
        tab_text_five
        om_two_column_image_left_v2_five {
            ...TwoColumnImageLeftV2
        }
        tab_text_six
        om_two_column_image_left_v2_six {
            ...TwoColumnImageLeftV2
        }
        button_action_type
        button_text
        button_url {
            ...Link
        }
        open_tab
        call_me_back {
            ...CallMeBack
        }
    }
`;

export default TabsTwoColumnImageLeftV2;
